import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

import PropTypes from 'prop-types';

const FixOrContinueModal = ({ open, onFix, onSave }) => {
  return (
    <Modal open={open} onClose={onFix} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 650,
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Errors detected with the data
        </Typography>
        <Typography variant="p" component="p">
          Would you like to fix the errors, or save your data and continue?
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 3,
          }}
        >
          <Button key={0} onClick={onFix}>
            Fix my errors
          </Button>
          <Button key={1} onClick={onSave}>
            Save and continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

FixOrContinueModal.propTypes = {
  open: PropTypes.bool,
  onFix: PropTypes.func,
  onSave: PropTypes.func,
};

export default FixOrContinueModal;
